import { z } from "zod";

// System setting value schema
export const systemSettingValueSchema = z.object({
	name: z.string().min(1).max(50),
	label: z.string(),
	valueFlag: z.boolean().nullable().optional(),
	valueString: z.string().nullable().optional(),
	valueNumber: z.number().nullable().optional(),
});

// System setting schema (full)
export const systemSettingSchema = z.object({
	name: z.string().min(1).max(50),
	label: z.string().min(1).max(50),
	valueFlag: z.boolean().nullable().optional(),
	valueString: z.string().max(500).nullable().optional(),
	valueNumber: z.number().nullable().optional(),
	isPublic: z.boolean().default(false),
});

// System settings map schema
export const systemSettingsMapSchema = z.record(
	z.string(),
	systemSettingValueSchema,
);

// Note: API Response schemas moved to systemSettingsApiSchemas.ts

// The main schema for the plugin
export const systemSettingsSchema = {
	SystemSetting: systemSettingSchema,
};
